import { twMerge } from "tailwind-merge"
import { BASE_PATH } from "@/constants/app.mjs"
import CaseStudyCard, { type CaseStudy } from "./CaseStudyCard"
import { caseStudyRowCss } from "./FeaturedCaseStudiesCss"

const caseStudies: CaseStudy[] = [
  {
    id: "pendle",
    tagline:
      "Tracking adoption and performance for one of the largest asset management protocols.",
    href: "https://tokenterminal.com/resources/articles/customer-stories-token-terminal-s-data-partnership-with-pendle",
    backgroundImage: `${BASE_PATH}/static/images/marketing/app-partnership/case-study-background-pendle.svg`,
    logo: `${BASE_PATH}/static/images/marketing/app-partnership/logos/logo-pendle.svg`,
  },
  {
    id: "maple",
    tagline: "Improving onchain reporting for DeFi's institutional lender.",
    href: "https://tokenterminal.com/resources/articles/customer-stories-token-terminal-s-data-partnership-with-maple-finance",
    backgroundImage: `${BASE_PATH}/static/images/marketing/app-partnership/case-study-background-maple.svg`,
    logo: `${BASE_PATH}/static/images/marketing/app-partnership/logos/logo-maple.svg`,
  },
  {
    id: "etherfi",
    tagline:
      "Performance benchmarks for a leading liquid staking and restaking platform.",
    href: "https://tokenterminal.com/resources/articles/customer-stories-token-terminal-s-data-partnership-with-ether-fi1",
    backgroundImage: `${BASE_PATH}/static/images/marketing/app-partnership/case-study-background-etherfi.svg`,
    logo: `${BASE_PATH}/static/images/marketing/app-partnership/logos/logo-etherfi.svg`,
  },
  {
    id: "raydium",
    tagline: "Standardized financial metrics for Solana's leading DEX.",
    href: "https://tokenterminal.com/resources/articles/customer-stories-token-terminal-s-data-partnership-with-raydium",
    backgroundImage: `${BASE_PATH}/static/images/marketing/app-partnership/case-study-background-raydium.svg`,
    logo: `${BASE_PATH}/static/images/marketing/app-partnership/logos/logo-raydium.svg`,
  },
]

const FeaturedCaseStudies = () => {
  return (
    <div className="flex flex-col gap-6 items-center justify-center">
      <div className="text-sm text-fg-secondary">Case studies</div>
      <div className={twMerge("flex items-center gap-3", caseStudyRowCss)}>
        {caseStudies.map((caseStudy, _index) => (
          <CaseStudyCard caseStudy={caseStudy} key={caseStudy.id} />
        ))}
      </div>
    </div>
  )
}

export default FeaturedCaseStudies
